var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.professionals
      ? _c("section", [
          _vm.professionals.length === 0
            ? _c("div", { staticClass: "row my-4" }, [_vm._m(0)])
            : _c("div", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.professionals, function(professional, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-md-4 col-12" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "no-style",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.openTwitter(professional.id)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "card shadow-sm" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 p-0" },
                                    [
                                      _c("professional-picture", {
                                        attrs: {
                                          professional: professional,
                                          imgClass: "img-fluid",
                                          imgSize: 40
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-10" }, [
                                    _c("h3", { staticClass: "mb-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("firstName")(professional.name)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "professional-city" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("multiLangName")(
                                                _vm.globalState.cities[
                                                  professional.province_id
                                                ]
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "mt-3" }, [
                                      _c("i", {
                                        staticClass: "fas fa-star -rating-star"
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            professional.rating.toFixed(1)
                                          ) +
                                          "\n                       " +
                                          _vm._s(
                                            _vm.$tc(
                                              "message.professional.bookings",
                                              Number(professional.booking_qty)
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(professional.booking_qty) +
                                          "\n                    "
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
        ])
      : _c("section", [_c("loader")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "text-center mt-3 mb-4" }, [
      _vm.state.isMore
        ? _c(
            "a",
            {
              staticClass: "btn btn-info",
              attrs: { href: "", disabled: _vm.state.isFetching },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.loadMore.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.isLoadMore)) + "\n    ")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("div", [_c("i", { staticClass: "far fa-frown fa-6x" })]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _vm._v(
          "\n          ขออภัยค่ะ แคมเปญนี้สงวนสิทธิ์สำหรับลูกค้าที่เคยใช้บริการ BeNeat มาแล้วอย่างน้อย 1 ครั้งค่ะ"
        ),
        _c("br"),
        _vm._v(
          "\n          ร่วมแคมเปญได้ตั้งแต่วันนี้จนถึง 30 กันยายน 2563\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3 text-center" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "https://beneat.co/images/twitter_campaign_sep_2020.jpg",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
        _c("div", { staticClass: "my-4" }, [
          _c("h3", [_vm._v("สาวก Facebook & Twitter ฟังทางนี้!!!")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "รับ Coins ฟรี 30 บาท ทันที ไม่ต้องลุ้น สามารถนำไปใช้เป็นส่วนลดได้กับทุกบริการของเรา เพียงแนะนำคุณแม่บ้าน BeNeat ที่คุณชื่นชอบ"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "*เพื่อสิทธิ์ของท่าน กรุณาอย่าเปลี่ยนแปลงข้อความในส่วนของลิงค์ และ # แฮซแทก นะคะ สามารถบอกต่อความประทับใจได้ทั้ง 2 ช่องทาง"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("จำกัด ช่องทางละ 1 สิทธิ์/ User เท่านั้น")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("ร่วมกิจกรรมได้ตั้งแต่วันนี้ – 30 กันยายน 2563 นี้นะคะ")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d4e62e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d4e62e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Twitter.vue
// module id = 1517
// module chunks = 0